import { AxiosError, AxiosResponse } from 'axios';
import Toast from '../sys/toast';
import axios from 'axios';

const codes = {
    // these error codes get a special popup type, all others beside success are considered errors
    warnings: [-7, -8],
    debug: [-4, -14],

    // these errors should abort the request
    abortable: [-2, -3, -4, -5, -12, -13, -14, -18],

    // by default we popup for these rror codes
    defaultToast: [-2, -3, -4, -5, -9, -10, -11, -12, -13, -14, -16, -18, -100]
};

export class RequestResult {
    code: number;
    codename?: string;
    message?: string;
    policy?: string;

    static fromAxiosResponse(response: AxiosResponse) {
        let result = new RequestResult();
        if (response.headers['X-exception-extended']) {
            if (response.headers['X-exception-code'])
                result.code = response.headers['X-exception-code'];
            if (response.headers['X-exception-message'])
                result.message = response.headers['X-exception-message'];
            if (response.headers['X-exception-policy'])
                result.policy = response.headers['X-exception-policy'];
        } else {
            const { res, code, det } = response.data;
            if (res) result.code = res;
            if (code) result.codename = code;
            if (det) result.message = det;
        }

        if (result.code === 1) result.code = 0;  // re-alias 1 success code to 0
        if (result.codename === undefined)
            result.codename = RequestResult.getCodeName(result.code);
        
        return result;
    }

    static fromAxiosError(error: AxiosError) {
        let result = new RequestResult();
        if (axios.isCancel(error)) {
            result.code = -101;
            result.codename = 'request cancelled';
            result.message = 'The application cancelled the request before it completed';
        } else {
            result.code = -100;
            result.codename = 'request error';
            const httpcode = (error.response && error.response.status) || 0;
            result.message = 'http returned ' + httpcode;
        }
        return result;
    }

    static getCodeName(code: number) {
        switch (code) {
            case 0: return 'success';
            case 1: return 'success';
            case 100: return 'success';
            case -1: return 'generic failure';
            case -2: return 'syntax error';
            case -3: return 'invalid parameter(s)';
            case -4: return 'not implemented';
            case -5: return 'client rejected';
            case -6: return 'object not found';
            case -7: return 'already started';
            case -8: return 'already stopped';
            case -9: return 'resource busy';
            case -10: return 'license limit reached';
            case -11: return 'feature disabled';
            case -12: return 'missing post data in request';
            case -13: return 'expected parameter(s)';
            case -14: return 'internal error, contact your support representative';
            case -15: return 'object already exists (duplicate)';
            case -16: return 'requested resource unavailable';
            case -17: return 'inactive';
            case -18: return 'unlicensed for this operation';
            case -19: return 'multiple objects found where one was expected';
            case -20: return 'null object';
            case -21: return 'invalid pattern';
            case -100: return 'axios error';
            case -101: return 'request cancelled';
            default: return undefined;
        }
    }

    toast() {
        const msg = this.toString();
        if (codes.debug.findIndex(v => v === this.code) >= 0)
            Toast.debug(msg);
        else if (codes.warnings.findIndex(v => v === this.code) >= 0)
            Toast.warning(msg);
        else
            Toast.error(msg);
    }

    toastDefault() {
        if (codes.defaultToast.findIndex(v => v === this.code) >= 0)
           this.toast();
    }

    toastIf(codelist: number[]) {
        if (codelist.findIndex(v => v === this.code) >= 0)
            this.toast();
    }

    abortable() {
        return (codes.abortable.findIndex(v => v === this.code) >= 0);
    }

    toString() {
        const codename = this.codename || String(this.code);
        return this.message
            ? this.message
            : codename;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/result.tsx